import * as fs from 'node:fs';
import * as path from 'node:path';
import type { SimpleGit } from 'simple-git';
import { countTextFileLines } from '../lines/count-lines.js';
import { numstatFromGitNoIndex } from '../parse/numstat-from-git-no-index.js';
import type { NameStatusEntry } from '../parse/types.js';
import type { WorkingTreeChangeFileRow } from '../types.js';

export function createUntrackedStatsApplier(options: {
  g: SimpleGit;
  repoGitCwd: string;
  untrackedSet: Set<string>;
  nameByPath: Map<string, NameStatusEntry>;
}): (row: WorkingTreeChangeFileRow, pathInRepo: string) => Promise<void> {
  return async (row, pathInRepo) => {
    if (!options.untrackedSet.has(pathInRepo)) return;
    if (options.nameByPath.has(pathInRepo)) return;
    if (row.change === 'moved') return;

    const repoFilePath = path.join(options.repoGitCwd, pathInRepo);
    const fromGit = await numstatFromGitNoIndex(options.g, pathInRepo);
    if (fromGit) {
      row.additions = fromGit.additions;
      row.deletions = fromGit.deletions;
      return;
    }
    try {
      const st = await fs.promises.stat(repoFilePath);
      row.additions = st.isFile() ? await countTextFileLines(repoFilePath) : 0;
    } catch {
      row.additions = 0;
    }
    row.deletions = 0;
  };
}
